class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();

      // $(".upsell_products").slick({
      //   slidesToShow: 1.,
      //   slidesToScroll: 1,
      //   autoplay: false,
      //   dots: false,
      //   infinite: false,
      //   adaptiveHeight: true
      // })
  }

  couponCodeFunctionality() {
      const submitBtn = document.querySelector(".subMitBtn");
      
      submitBtn.addEventListener("click", function() {
        const allCoupons = this.getAttribute("data-coupons");;
        const newArray = allCoupons.split(",");
        const setVal = this.previousElementSibling.value;
      
        document.querySelector("input.js-form-discount").value = setVal;
      
        if (newArray.includes(setVal)) {
          document.querySelector('.js-form-discount').setAttribute('value', setVal);
          document.querySelector('.couponMsg').innerHTML = "<span class='succ'>Success! Coupon has been added to the checkout page.</span>";
        } else if (setVal === "") {
          document.querySelector('.couponMsg').innerHTML = "<span class='empty'>Please add a coupon code!</span>";
        } else {
          document.querySelector('.couponMsg').innerHTML = "<span class='err'>Error! Please add a valid coupon code.</span>";
        }
      }); 
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
    setTimeout(() => {
      this.couponCodeFunctionality();
    }, 500)

    // let freeProduct = Number(document.querySelector("#free_prod")?.value);
    // let triggerProducts = document.querySelector(".trigger_prods")?.textContent.trim().split(",");
    // let cartPros = document.querySelectorAll(".cart-item");
    // let productAche = false;
    
    // console.log("triggerProductRaw", triggerProducts);
    // console.log("freeProduct", freeProduct);
    // cartPros.forEach((cartPro)=>{
    //   let itemId = cartPro.querySelector(".cart-item__name").getAttribute("href").split("&variant=")[1];
    //   if(triggerProducts.includes(itemId)){
    //     productAche = true;
    //   }
    // });
    // console.log(productAche);
    
    // const TRIGGER_VARIANT_IDS = [48007395475755, 49595931459883];
    // const COMPLEMENTARY_VARIANT_ID = 48002576187691;
    // console.log("Trigger item:", TRIGGER_VARIANT_IDS);
    // console.log("Complementary item:", COMPLEMENTARY_VARIANT_ID);
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      console.log("**section**",section);
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      // console.log("**ParsedState**", parsedState)
      // console.log("**ParsedState section id**", parsedState.sections[section.id]);
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
    this.couponCodeFunctionality();
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);


